<template>
  <q-layout view="hHh lpR fff">
    <!-- <Header /> -->
    <div v-if="this.$router.currentRoute._value.fullPath == '/pencarian'">
    </div>
    <div v-else>
      <q-header v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" elevated class="bg-white text-black header-text shadow-2" style="padding: 10px 90px;">
        <div class="row no-wrap">
          <q-toolbar class="col-6">
            <q-toolbar-title> 
              <router-link to="/">
              <q-img src="img/marina.png" style="height: auto; max-width: 150px" />
              </router-link>
            </q-toolbar-title>
          </q-toolbar>
          <q-toolbar class="col-6">
            <q-input
              v-model="cari_value"
              debounce="500"
              outlined
              :dense="true"
              class="cari-data bg-white"
              color="purple-12"
              @keydown.enter="submit()"
              placeholder="Cari Produk..."
            >
              <template v-slot:append>
                <q-icon name="search" @click="submit()" style="font-size: 18px;" color="purple-12" />
              </template>
            </q-input>
          </q-toolbar>
          <!-- <q-toolbar class="col-4">
            <q-space />
            <q-tabs no-caps outside-arrows mobile-arrows inline-label active-color="purple-12">
              <q-route-tab to="/produk" label="Produk" icon="sym_o_shopping_bag" />
              <q-route-tab to="/wishlist" label="Wishlist" icon="sym_o_favorite" />
              <q-route-tab to="/keranjang" icon="sym_o_shopping_cart" label="Keranjang" />
              <q-route-tab v-if="cek_login == 1" to="/login" class="text-purple-12" icon="lock" >
                <q-tooltip
                  transition-show="flip-right"
                  transition-hide="flip-left"
                  class="bg-purple-12 text-white"
                >
                  Login
                </q-tooltip>
              </q-route-tab>
              <q-route-tab v-if="cek_login == 0" to="/akun" class="text-purple-12" icon="person" >
                <q-tooltip
                  transition-show="flip-right"
                  transition-hide="flip-left"
                  class="bg-purple-12 text-white"
                >
                  Akun
                </q-tooltip>
              </q-route-tab>
            </q-tabs>
          </q-toolbar> -->
        </div>
      </q-header>
      <q-header v-if="$q.screen.lt.sm" elevated class="bg-white text-black header-text shadow-1" style="padding: 10px 20px 10px 10px;">
        <div class="row no-wrap">
          <q-toolbar class="col-4">
            <q-toolbar-title>
              <router-link to="/">
                <q-img src="img/marina.png" style="height: auto; max-width: 200px" />
              </router-link>
            </q-toolbar-title> 
          </q-toolbar>
          <q-toolbar class="col-8">
            <q-input
              v-model="cari_value"
              debounce="500"
              outlined
              :dense="true"
              class="cari-data bg-white"
              color="purple-12"
              @keydown.enter="submit()"
              placeholder="Cari Produk..."
            >
              <template v-slot:append>
                <q-icon name="search" style="font-size: 18px;" color="purple-12" />
              </template>
            </q-input>
          </q-toolbar>
          <!-- <q-toolbar class="col-2">
            <q-space />
            <q-btn dense flat round icon="menu" @click="rightDrawerOpen = !rightDrawerOpen"  />
          </q-toolbar> -->
        </div>
      </q-header>
      <!-- <q-drawer v-model="rightDrawerOpen" side="right" width="250" overlay behavior="mobile" elevated>
        <q-scroll-area class="fit"> 
              <q-list class="q-pa-sm">
                  <q-item clickable to="/produk" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_shopping_bag" />
                    </q-item-section>
                    <q-item-section>
                      Produk
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item clickable to="/wishlist" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_favorite" />
                    </q-item-section>
                    <q-item-section>
                      Wishlist
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item clickable to="/keranjang" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_shopping_cart" />
                    </q-item-section>
                    <q-item-section>
                      Keranjang
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item v-if="cek_login == 1" clickable to="/login" class="text-purple-12 text-weight-bold" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="lock" color="purple-12" />
                    </q-item-section>
                    <q-item-section>
                      Login
                    </q-item-section>
                  </q-item>
                  <q-item v-if="cek_login == 0" clickable to="/akun" class="text-purple-12 text-weight-bold" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="person" color="purple-12" />
                    </q-item-section>
                    <q-item-section>
                      Akun
                    </q-item-section>
                  </q-item>
                </q-list>
        </q-scroll-area>      
      </q-drawer>    -->
    </div>
    <q-page-container>
      <router-view v-bind:artists="artists" />
    </q-page-container>
    <div v-if="this.$router.currentRoute._value.fullPath == '/pencarian'">
    </div>
    <div v-else>
      <q-footer v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" bordered class="bg-grey-1">
        <div class="row footer-area">
          <div class="col-12 col-md-4 footer-right">
            <q-img src="img/marina.png" style="width: 125px; margin-bottom: 15px;" />
            <div class="footer-text">
              Marina Market-Place merupakan media bagi perempuan pelaku usaha produk rumah tangga di Kabupaten Konawe Selatan
            </div>
            <div class="row footer-text">
              <div class="col-1">
                <q-icon name="pin_drop" class="footer-icon" />
              </div>
              <div class="col-11">
                Dinas Pemberdayaan Perempuan & Perlindungan Anak Kabupaten Konawe Selatan
              </div>
            </div>
            <div class="row footer-text">
              <div class="col-1">
                <q-icon name="mail" class="footer-icon" />
              </div>
              <div class="col-11">
                marina@konaweselatankab.go.id
              </div>
            </div>
            <div class="row footer-text">
              <div class="col-1">
                <q-icon name="call" class="footer-icon" />
              </div>
              <div class="col-11">
                +91 123 4567890
              </div>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="footer-title">
              Market-Place
            </div>
            <div class="footer-text">
              Tentang Marina
            </div>
            <div class="footer-text">
              Kebijakan Privasi
            </div>
            <div class="footer-text">
              Syarat & Ketentuan
            </div>
            <div class="footer-text">
              Hubungi Kami
            </div>
            <div class="footer-text">
              Pusat Bantuan
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="footer-title">
              Kategori
            </div>
            <div class="footer-text">
              Cemilan
            </div>
            <div class="footer-text">
              Kerajinan Tangan
            </div>
            <div class="footer-text">
              Olahan Pangan
            </div>
            <div class="footer-text">
              Hasil Pertanian
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="footer-title">
              Marina Market-Place
            </div>
            <div>
              <q-input
                v-model="cari_value"
                debounce="500"
                outlined
                :dense="true"
                class="cari-data bg-white"
                color="purple-12"
                @keydown.enter="submit()"
                placeholder="Cari Produk..."
              >
                <template v-slot:append>
                  <q-icon name="search" @click="submit()" style="font-size: 18px;" color="purple-12" />
                </template>
              </q-input>
            </div>
            <div style="margin: 20px 0;">
              <q-img v-for="data in produk" :src="file_path+data.file" @click="push_produk(data.id)" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <!-- <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 80.25px; height: 80.25px; margin: 2.5px;" /> -->
            </div>
          </div>
        </div>
        <div class="footer-marina">
          &#169; 2024 | <span class="footer-span"> Marina</span>, All rights reserved.
        </div>
      </q-footer>
      <q-footer v-if="$q.screen.lt.sm" bordered class="bg-grey-1">
        <div class="row footer-area-android">
          <div class="col-4 footer-right-android">
            <q-img src="img/marina.png" style="width: 75px; margin-bottom: 7.5px;" />
            <div class="footer-text-android">
              Marina Market-Place merupakan media bagi perempuan pelaku usaha produk rumah tangga di Kabupaten Konawe Selatan
            </div>
            <div class="row footer-text-android">
              <div class="col-1">
                <q-icon name="pin_drop" class="footer-icon" />
              </div>
              <div class="col-11">
                Dinas Pemberdayaan Perempuan & Perlindungan Anak Kabupaten Konawe Selatan
              </div>
            </div>
            <div class="row footer-text-android">
              <div class="col-1">
                <q-icon name="mail" class="footer-icon" />
              </div>
              <div class="col-11">
                marina@konaweselatankab.go.id
              </div>
            </div>
            <div class="row footer-text-android">
              <div class="col-1">
                <q-icon name="call" class="footer-icon" />
              </div>
              <div class="col-11">
                +91 123 4567890
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="footer-title-android">
              Market-Place
            </div>
            <div class="footer-text-android">
              Tentang Marina
            </div>
            <div class="footer-text-android">
              Kebijakan Privasi
            </div>
            <div class="footer-text-android">
              Syarat & Ketentuan
            </div>
            <div class="footer-text-android">
              Hubungi Kami
            </div>
            <div class="footer-text-android">
              Pusat Bantuan
            </div>
          </div>
          <div class="col-2">
            <div class="footer-title-android">
              Kategori
            </div>
            <div class="footer-text-android">
              Cemilan
            </div>
            <div class="footer-text-android">
              Kerajinan Tangan
            </div>
            <div class="footer-text-android">
              Olahan Pangan
            </div>
            <div class="footer-text-android">
              Hasil Pertanian
            </div>
          </div>
          <div class="col-4">
            <div class="footer-title-android">
              Marina Market-Place
            </div>
            <div style="margin: 0 0 10px;">
              <q-img v-for="data in product" :src="file_path+data.file" @click="push_produk(data.id)" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <!-- <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" />
              <q-img src="img/banner-1.png" style="border-radius: 5px; width: 25.5px; height: 25.5px; margin: 0 1.5px 1.5px;" /> -->
            </div>
          </div>
        </div>
        <div class="footer-marina" style="font-size: 7.5px;">
          &#169; 2024 | <span class="footer-span"> Marina</span>, All rights reserved.
        </div>
      </q-footer>
    </div>
  </q-layout>
</template>


<script>
// import Header from './components/Header.vue'

export default {
  name: 'app',
  // components: { Header },

  data () {
    return {
      rightDrawerOpen:false,
      cek_login : 0,
      cari_value : '',
      artists: [ { name: '' }, ],
      produk : [],
      product : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",
    }
  },
  methods: {

    submit() {
      this.artists[0].name = this.cari_value;
      this.$router.push('/pencarian');
    },

    getProduk : function(){
      fetch(this.$store.state.url.URL_BERANDA  + "footerProduk", {
          method: "GET",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.produk = res_data.data;
      });
    },

    getProduct : function(){
      fetch(this.$store.state.url.URL_BERANDA  + "footerProduct", {
          method: "GET",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.product = res_data.data;
      });
    },

},
  mounted: function(){
    if (localStorage.token == undefined) {
      this.cek_login = 1;
    } else {
      this.cek_login = 0 
    }
    this.getProduk();
    this.getProduct();
  },
}
</script>